import { render, staticRenderFns } from "./bid-attachments.vue?vue&type=template&id=c9c096e0&"
import script from "./bid-attachments.vue?vue&type=script&lang=js&"
export * from "./bid-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports